import { useRouter } from 'next/router'
import { paths } from '@mc/paths'
import { Locations } from '@mc/track-event'

import EnterpriseCTA from 'components/EnterpriseCTA'

import {
  getPageSourceFromPath,
  shouldHideEnterpriseCTAInNav,
  shouldScrollToForm,
} from './utils'

export const NavActions = () => {
  const { pathname, query } = useRouter()

  if (shouldHideEnterpriseCTAInNav(pathname)) return <></>

  return (
    <EnterpriseCTA
      size='sm'
      className='mc-ml-8'
      pageSource={getPageSourceFromPath({ pathname, query })}
      location={Locations.NAVIGATION}
      scrollToForm={shouldScrollToForm(pathname)}
      href={
        shouldScrollToForm(pathname)
          ? '#contact-form'
          : paths.enterprisePurchase
      }
    />
  )
}
